export default "<p>forgot-password works!</p>\n"